import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

type StyledButtonProps = {
  right?: boolean
}

const shouldForwardProp = (prop: string) => !['right'].includes(prop)

const styledButtonRightCss = ({ right }: StyledButtonProps) =>
  right &&
  css`
    left: unset;
    right: 0;
  `

export const StyledButton = styled.button.withConfig({
  shouldForwardProp,
})<StyledButtonProps>`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-100%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: ${themeGet('colors.primary.main')};
  color: ${themeGet('colors.text.inverse')};
  z-index: 2;

  ${styledButtonRightCss}
`
